<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form :inline="false" label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="7">
            <!--装车时间-->
            <el-form-item :label="$t('GlobalSetObj.LoadCarTime')">
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :format="$i18n.locale == 'zh' ? zhDate : ptDate"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 装车人   -->
            <el-form-item :label="$t('GlobalSetObj.Carregador')">
              <el-select
                v-model.trim="queryForm.params.loadUserIdList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getOperationUserInfo"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @focus="getOperationUserInfo('')"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--   网点所属州   -->
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.stateSite1')">
              <el-select
                v-model="queryForm.params.loadSiteStates"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 所属转运中心 -->
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.owningTransitCenter1')">
              <el-select
                v-model="queryForm.params.loadSiteDepartmentIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in departmentList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <!--  车牌号 -->
          <el-col :span="4">
            <el-form-item prop="selectType">
              <template slot="label">
                <div class="selectLabel">
                  <el-select
                    v-model="queryForm.params.queryType"
                    :style="IsWidth"
                    @change="getVehicleTagNumber01"
                  >
                    <el-option key="1" :label="$t('GlobalSetObj.licensePlateNumber')" :value="1" />
                    <el-option key="2" :label="$t('GlobalSetObj.NIV')" :value="2" />
                  </el-select>
                </div>
              </template>
              <el-input
                v-model="numberList"
                :placeholder="$t('collectionCenter.max2000Line')"
                clearable
                :rows="1"
                type="textarea"
                @blur="ft"
                @keydown.enter.native="BlockNewNumberline"
              />
            </el-form-item>
          </el-col>
          <!--  车牌号 -->
          <el-col :span="5">
            <el-form-item prop="scanNumberType">
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.scanNumberType" :style="IsWidth">
                    <el-option key="3" :label="$t('GlobalSetObj.waybillNumber')" :value="1" />
                    <el-option key="4" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
                  </el-select>
                </div>
              </template>
              <el-input
                v-model="queryForm.params.waybillNumber"
                :placeholder="$t('collectionCenter.max2000Line')"
                clearable
                :rows="1"
                style="width: 100%"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--   装车网点   -->
            <el-form-item :label="$t('customerManagements.loadSiteIdList')">
              <el-select
                v-model="queryForm.params.loadSiteIdList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getSiteList"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @focus="getSiteList('')"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--   下一站   -->
            <el-form-item :label="$t('GlobalSetObj.nextStation')">
              <el-select
                v-model="queryForm.params.nextSiteIdList"
                :remote-method="getSiteList"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @focus="getSiteList('')"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <el-button
              icon="el-icon-upload2"
              size="small"
              style="margin-bottom: 10px"
              @click="allExportOrder(1)"
            >{{ $t('newOrder.export') }}
            </el-button>
            <el-button
              v-permit:remove="'btn:deliveryLoading:airExportOrder'"
              size="small"
              style="margin-bottom: 10px"
              @click="airExportOrder"
            >{{ $t('GlobalSetObj.exportDIR') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <!--导出包裹明细-->
            <el-button icon="el-icon-upload2" size="small" @click="allExportOrder(2)">
              {{ $t('newOrder.ExportPackageDetails') }}
            </el-button>
            <!-- 跨境发票信息导出 -->
            <el-button size="small" @click="allExportOrder(3)">
              {{ $t('changepwd.exportCrossBorderInvoice') }}
            </el-button>
            <!-- 明细导出 -->
            <el-button size="small" @click="detailedExport()">
              {{ $t('navbar.DetailedExport') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <!--  表格数据  -->
      <el-table
        :data="tableDataWithSummary"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        :span-method="spanMethod"
        border
        style="width: 100%"
      >
        <el-table-column
          :label="`${$t('GlobalSetObj.serial', 'zh')}（${$t('GlobalSetObj.serial', 'pu')}）`"
          align="center"
          prop="serialNumber"
          width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isSummaryRow" class="text-total">本页合计(Total desta página)：<span class="text-color-33B44E">{{
              tableData.length
            }}</span></span>
            <span v-else>{{ scope.row.serialNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.isSummaryRow">
              <div v-if="fields.includes(item.prop)">
                <!--              车牌号显示文案-->
                <span v-if="item.prop === 'vehicleNumber'" class="text-total">车牌数量 (Número de placas)：</span>
                <!--              车签号显示文案-->
                <span v-else-if="item.prop === 'vehicleTagNumber'" class="text-total">车签数量 (Número de VNI)：</span>
                <!--              下一站和封签号显示文案-->
                <span
                  v-else-if="['nextSiteName', 'sealNumber'].includes(item.prop)"
                  class="text-total"
                >数量 (Número)：</span>
                <!--          其它显示本页总数    -->
                <span v-else class="text-total">本页总数 (Número total de sacos)：</span>
                <span class="text-color-33B44E">{{ pageSumLoad[fieldToTotalMap[item.prop]] }}</span>
              </div>
            </template>
            <template v-else>
              <div v-if="item.prop === 'sumIsUnload'">
                <div v-if="scope.row['sumIsUnload'] === 1">
                  {{ `${$t('GlobalSetObj.yes', 'zh')}（${$t('GlobalSetObj.yes', 'pu')}）` }}
                </div>
                <div v-else style="color: #f56c6c">
                  {{ `${$t('GlobalSetObj.No', 'zh')}（${$t('GlobalSetObj.No', 'pu')}）` }}
                </div>
              </div>
              <div
                v-else
                :class="
                  strARR.includes(item.prop) && scope.row[item.prop] != '0' ? 'WaybillNumber' : ''
                "
                @click="seeDetial01(scope.row, scope.row[item.prop], item.numberType)"
              >
                {{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableHeaderList1"
          :key="item.id"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.isSummaryRow">
              <div v-if="fields.includes(item.prop)">
                <span class="text-total">本页总数 (Número total de sacos)：</span>
                <span class="text-color-33B44E">{{ pageSumLoad[fieldToTotalMap[item.prop]] }}</span>
              </div>
            </template>
            <template v-else>
              <div
                :class="
                  strARR.includes(item.prop) && scope.row[item.prop] != '0' ? 'WaybillNumber' : ''
                "
                @click="seeDetial(scope.row, scope.row[item.prop], item.numberType)"
              >
                {{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          :label="`${$t('GlobalSetObj.operate', 'zh')}（${$t('GlobalSetObj.operate', 'pu')}）`"
          min-width="150"
          prop="varianceNumber"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.isSummaryRow"
              class="WaybillNumber"
              @click="seeDetialImage(scope.row)"
            >
              {{ `${$t('navbar.seeImage', 'zh')}（${$t('navbar.seeImage', 'pu')}）` }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.number"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!-- 袋号明细 -->
    <el-drawer
      :title="$t('GlobalSetObj.BagNumbeDetail')"
      :visible.sync="dialogVisible01"
      center
      direction="ltr"
      size="1200px"
      @close="closeDrawer"
    >
      <detail01
        v-if="dialogVisible01"
        ref="votesDetails"
        :dataobj="dataObj"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
    <!-- 包裹明细 -->
    <el-drawer
      :title="$t('customerManagements.packageDetail')"
      :visible.sync="dialogVisible"
      center
      direction="ltr"
      size="1200px"
      @close="closeDrawer"
    >
      <packageDetail
        v-if="dialogVisible"
        ref="votesDetails"
        :dataobj="dataObj"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
    <!-- 查看图片 -->
    <el-drawer
      :title="$t('navbar.loadImage')"
      :visible.sync="photoSeeRefVisible"
      center
      direction="ltr"
      size="900px"
      @close="closeDrawer"
    >
      <photoSee v-if="photoSeeRefVisible === true" ref="photoSeeRef" :dataobj="dataObj" />
    </el-drawer>
    <!--明细导出-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('navbar.DetailedExport')"
      :visible.sync="showDetailedExport"
      top="5%"
      width="600px"
    >
      <div style="padding: 20px 0">
        <el-radio-group v-model="statusType">
          <!--未卸车包裹数-->
          <el-radio :label="1">{{ $t('navbar.notUnLoadPackageNumber') }}</el-radio>
          <!--未分拣包裹数-->
          <el-radio :label="2">{{ $t('navbar.UnsortedPackages') }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDetailedExport = false">{{ $t('collectionCenter.cancel') }}
        </el-button>
        <el-button size="small" type="primary" @click="confirmExportDetail">{{ $t('collectionCenter.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLgAreaListData,
  getSiteTransfer,
  loadUnloadSumExportAll,
  loadUnloadSumExportDetail,
  loadUnloadSumpageQuery,
  loadUnloadSumuserAndSite,
  tfkDirExport
} from '@/api/orderApi';
import dayjs from 'dayjs';
import { loadUnloadSumTfkInfo } from '@/api/newExpressAPI';
import { goRWExportList } from '@/utils/goExportList';
import { fields, fieldToTotalMap } from '@/views/ReportManagement/DeliveryLoading/utils';

export default {
  name: 'DeliveryLoading',
  components: {
    detail01: () => import('./component/detail01'),
    packageDetail: () => import('./component/packageDetail'),
    photoSee: () => import('./component/photoSee')
  },
  data() {
    return {
      notEnter: true, // 是否允许换行
      numberList: '',
      departmentList: [], // 转运中心
      stateList: [],
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        number: 1,
        total: 0,
        params: {
          numberList: [],
          queryType: 1,
          scanNumberType: 1,
          loadSiteIdList: [], // 装车网点
          nextSiteIdList: [], // 下一站
          loadUserIdList: [], // 装车人
          loadSiteStates: [],
          loadSiteDepartmentIds: [],
          waybillNumber: ''
        }
      },
      siteList: [], // 网点
      tableData: [],
      userList: [], // 用户列表
      dialogVisible: false, // 详情弹窗
      dataObj: {},
      dialogVisible01: false,
      photoSeeRefVisible: false,
      tableHeaderList: [
        {
          label: `${this.$t('GlobalSetObj.LoadCarTime', 'zh')}（${this.$t(
            'GlobalSetObj.LoadCarTime',
            'pu'
          )}）`,
          prop: 'loadTime',
          cloWidth: 130
        },
        {
          label: `${this.$t('GlobalSetObj.licensePlateNumber', 'zh')}（${this.$t(
            'GlobalSetObj.licensePlateNumber',
            'pu'
          )}）`,
          prop: 'vehicleNumber',
          cloWidth: 150
        },
        {
          label: `${this.$t('navbar.vehicleDriver', 'zh')}（${this.$t(
            'navbar.vehicleDriver',
            'pu'
          )}）`,
          prop: 'vehicleDriver',
          cloWidth: 150
        },
        {
          label: `${this.$t('GlobalSetObj.NIV', 'zh')}（${this.$t('GlobalSetObj.NIV', 'pu')}）`,
          prop: 'vehicleTagNumber',
          cloWidth: 110
        },
        {
          label: `${this.$t('GlobalSetObj.Carregador', 'zh')}（${this.$t(
            'GlobalSetObj.Carregador',
            'pu'
          )}）`,
          prop: 'loadUserName',
          cloWidth: 150
        },
        {
          label: `${this.$t('collectionCenter.stateSite1', 'zh')}（${this.$t(
            'collectionCenter.stateSite1',
            'pu'
          )}）`,
          prop: 'loadSiteState',
          cloWidth: 120
        },
        {
          label: `${this.$t('collectionCenter.owningTransitCenter1', 'zh')}（${this.$t(
            'collectionCenter.owningTransitCenter1',
            'pu'
          )}）`,
          prop: 'loadSiteDepartmentName',
          cloWidth: 120
        },
        {
          label: `${this.$t('customerManagements.loadSiteIdList', 'zh')}（${this.$t(
            'customerManagements.loadSiteIdList',
            'pu'
          )}）`,
          prop: 'loadSiteName',
          cloWidth: 120
        },
        {
          label: `${this.$t('GlobalSetObj.nextStation', 'zh')}（${this.$t(
            'GlobalSetObj.nextStation',
            'pu'
          )}）`,
          prop: 'nextSiteName',
          cloWidth: 160
        },
        {
          label: `${this.$t('GlobalSetObj.sealNumber', 'zh')}（${this.$t(
            'GlobalSetObj.sealNumber',
            'pu'
          )}）`,
          prop: 'sealNumber',
          cloWidth: 150
        },
        {
          label: `${this.$t('GlobalSetObj.sealVehicleTime', 'zh')}（${this.$t(
            'GlobalSetObj.sealVehicleTime',
            'pu'
          )}）`,
          prop: 'sealVehicleTime',
          cloWidth: 160
        },
        {
          label: `${this.$t('GlobalSetObj.unsealVehicleTime', 'zh')}（${this.$t(
            'GlobalSetObj.unsealVehicleTime',
            'pu'
          )}）`,
          prop: 'unsealVehicleTime',
          cloWidth: 160
        },
        {
          label: `${this.$t('navbar.sumIsUnload', 'zh')}（${this.$t('navbar.sumIsUnload', 'pu')}）`,
          prop: 'sumIsUnload',
          cloWidth: 160
        },
        {
          label: `${this.$t('customerManagements.loadBags', 'zh')}（${this.$t(
            'customerManagements.loadBags',
            'pu'
          )}）`,
          prop: 'loadBagNumber',
          cloWidth: 160,
          numberType: 1
        },
        {
          label: `${this.$t('navbar.unLoadBagNumber', 'zh')}（${this.$t(
            'navbar.unLoadBagNumber',
            'pu'
          )}）`,
          prop: 'unLoadBagNumber',
          cloWidth: 160,
          numberType: 2
        },
        {
          label: `${this.$t('navbar.errorUnLoadBagNumber', 'zh')}（${this.$t(
            'navbar.errorUnLoadBagNumber',
            'pu'
          )}）`,
          prop: 'errorUnLoadBagNumber',
          cloWidth: 160,
          numberType: 3
        },
        {
          label: `${this.$t('navbar.notUnLoadBagNumber', 'zh')}（${this.$t(
            'navbar.notUnLoadBagNumber',
            'pu'
          )}）`,
          prop: 'notUnLoadBagNumber',
          cloWidth: 160,
          numberType: 4
        }
      ],
      tableHeaderList1: [
        {
          label: `${this.$t('customerManagements.loadPackageNumber', 'zh')}（${this.$t(
            'customerManagements.loadPackageNumber',
            'pu'
          )}）`,
          prop: 'loadPackageNumber',
          cloWidth: 160,
          numberType: 1
        },
        {
          label: `${this.$t('customerManagements.unLoadPackageNumber', 'zh')}（${this.$t(
            'customerManagements.unLoadPackageNumber',
            'pu'
          )}）`,
          prop: 'unLoadPackageNumber',
          cloWidth: 160,
          numberType: 2
        },
        {
          label: `${this.$t('navbar.errorUnLoadPackageNumber', 'zh')}（${this.$t(
            'navbar.errorUnLoadPackageNumber',
            'pu'
          )}）`,
          prop: 'errorUnLoadPackageNumber',
          cloWidth: 160,
          numberType: 3
        },
        {
          label: `${this.$t('navbar.notUnLoadPackageNumber', 'zh')}（${this.$t(
            'navbar.notUnLoadPackageNumber',
            'pu'
          )}）`,
          prop: 'notUnLoadPackageNumber',
          cloWidth: 160,
          numberType: 4
        },
        {
          label: `${this.$t('navbar.SortingPackages', 'zh')}（${this.$t(
            'navbar.SortingPackages',
            'pu'
          )}）`,
          prop: 'sortingPackageNumber',
          cloWidth: 160,
          numberType: 5
        },
        {
          label: `${this.$t('navbar.UnsortedPackages', 'zh')}（${this.$t(
            'navbar.UnsortedPackages',
            'pu'
          )}）`,
          prop: 'notSortingPackageNumber',
          cloWidth: 180,
          numberType: 6
        }
      ],
      strARR: [
        'loadBagNumber',
        'unLoadBagNumber',
        'errorUnLoadBagNumber',
        'notUnLoadBagNumber',
        'loadPackageNumber',
        'unLoadPackageNumber',
        'errorUnLoadPackageNumber',
        'notUnLoadPackageNumber',
        'sortingPackageNumber',
        'notSortingPackageNumber'
      ],
      pageSumLoad: {}, // 统计数据
      showDetailedExport: false,
      statusType: null
    };
  },
  computed: {
    fieldToTotalMap() {
      return fieldToTotalMap;
    },
    fields() {
      return fields;
    },
    IsWidth() {
      return {
        width: this.isTormat ? '170px' : '120px'
      };
    },
    // 添加汇总行的表格数据
    tableDataWithSummary() {
      if (!this.tableData || this.tableData.length === 0) {
        return [];
      }

      // 创建汇总行数据
      const summaryRow = {
        isSummaryRow: true,
        serialNumber: '',
        ...this.createSummaryRowData()
      };

      // 为原始数据添加序号
      const dataWithSerial = this.tableData.map((item, index) => ({
        ...item,
        serialNumber: index + 1,
        isSummaryRow: false
      }));

      // 将汇总行放在第一行
      return [summaryRow, ...dataWithSerial];
    }
  },
  watch: {
    numberList(val) {
      let bgh = val.split('\n');
      // 过滤空项
      bgh = bgh.filter(function(f) {
        return f && f.trim();
      });
      // 去除空格
      const bghTrim = bgh.map((item) => {
        return item.replace(/\s/g, '').trim();
      });
      let number = [];
      if (bghTrim.length >= 2000) {
        number = bghTrim.slice(0, 2000).join('\n');
        this.numberList = number;
        this.notEnter = false;
      } else {
        this.notEnter = true;
      }
      if (bghTrim.length > 2000) {
        this.$message.warning(this.$t('collectionCenter.intercep2')); // '单次查询最多100条，已截取前100条数据'
      }
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    // this.queryForm.params.loadSiteIdList = [this.$store.getters.siteId];
    this.getTimer();
    this.getSearch('');
    this.getState();
    this.getDepartment();
  },
  methods: {
    // 明细导出
    detailedExport() {
      this.showDetailedExport = true;
      this.statusType = null;
    },
    // 确定导出明细
    confirmExportDetail() {
      if (this.statusType === '' || this.statusType === null || this.statusType === undefined) {
        this.$message.warning(this.$t('navbar.PleaseSelectTheExportedPackageType'));
        return;
      }
      const data = {};
      if ((!this.timeValue || this.timeValue.length <= 0) && !this.numberList) {
        this.$message.warning(this.$t('GlobalSetObj.selectTime'));
        return;
      }
      if (this.timeValue && this.timeValue.length > 0) {
        data.loadStartTime = this.timeValue[0];
        data.loadEndTime = this.timeValue[1];
      } else {
        data.loadStartTime = '';
        data.loadEndTime = '';
      }

      data.queryType = this.queryForm.params.queryType;
      data.loadSiteIdList = this.queryForm.params.loadSiteIdList;
      data.nextSiteIdList = this.queryForm.params.nextSiteIdList;
      data.numberList = this.queryForm.params.numberList;
      data.loadUserIdList = this.queryForm.params.loadUserIdList;
      data.loadSiteStates = this.queryForm.params.loadSiteStates;
      data.loadSiteDepartmentIds = this.queryForm.params.loadSiteDepartmentIds;
      data.statusType = this.statusType;
      console.log(data, '===params');
      // 导出明细
      loadUnloadSumExportDetail(data).then((res) => {
        if (res.code === 200) {
          this.showDetailedExport = false;
          goRWExportList(this);
        }
      });
    },
    ft() {
      const val = this.numberList.split('\n');
      // 过滤空项
      const numLen = val.filter(function(f) {
        return f && f.trim();
      });
      // 去除空格
      const bghTrim = numLen.map((item) => {
        return item.replace(/\s/g, '').trim();
      });
      this.numberList = bghTrim.join('\n');
      this.queryForm.params.numberList = bghTrim;
    },
    BlockNewNumberline() {
      // 文本域最大输入行数为1000
      const e = window.event || arguments[0];
      this.ft();
      const numberLen = this.numberList.split('\n');
      if (!this.notEnter) {
        if (numberLen.length >= 2000) {
          this.$message.warning(this.$t('collectionCenter.intercep2')); // '单次查询最多100条，已截取前100条数据'
        }
        e.returnValue = false;
        return true;
      }
    },
    getState() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    getDepartment() {
      // 转运中心
      getSiteTransfer()
        .then((res) => {
          if (res.code === 200) {
            this.departmentList = res.data;
          }
        })
        .catch({});
    },
    enterSearch() {
      this.queryForm.number = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.number = 1;
      this.isTest = 1;
      this.getTimer();
      this.queryForm.params = {
        numberList: [],
        queryType: 1,
        scanNumberType: 1,
        loadSiteIdList: [], // 装车网点
        nextSiteIdList: [], // 下一站
        loadUserIdList: [], // 装车人
        loadSiteStates: [],
        loadSiteDepartmentIds: [],
        waybillNumber: ''
      };
      this.getVehicleTagNumber01();
      this.getSearch();
    },
    parentMethod(arg) {
      this.dialogVisible = arg;
      this.dialogVisible01 = arg;
      this.photoSeeRefVisible = arg;
    },
    seeDetial(row, number, queryType) {
      console.log(row, number, 'number');
      this.dataObj = {
        id: row.id, // 列表id
        nextSiteId: row.nextSiteId, // 下一站
        vehicleNumber: row.vehicleNumber,
        tagNumber: row.vehicleTagNumber,
        queryType: queryType // 查询类型 1装车包裹数,2卸车包裹数,3差异数量
      };
      if (queryType) {
        if (number == '0' || number === '--' || number === null) {
          console.log('详情');
        } else {
          this.dialogVisible = true;
        }
      }
    },
    seeDetial01(row, number, queryType) {
      this.dataObj = {
        id: row.id, // 列表id
        nextSiteId: row.nextSiteId, // 下一站
        vehicleNumber: row.vehicleNumber,
        tagNumber: row.vehicleTagNumber,
        queryType: queryType // 查询类型 1装车包裹数,2卸车包裹数,3差异数量
      };
      console.log(this.dataObj, 'dataObj');
      if (queryType) {
        if (number == '0' || number === '--' || number === null) {
          console.log('详情');
        } else {
          this.dialogVisible01 = true;
        }
      }
    },
    seeDetialImage(row) {
      this.dataObj = {
        id: row.id, // 列表id
        nextSiteId: row.nextSiteId, // 下一站
        vehicleTagNumber: row.vehicleTagNumber
      };
      this.photoSeeRefVisible = true;
    },
    // 查询
    getSearch(val) {
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.number;
      if ((!this.timeValue || this.timeValue.length <= 0) && !this.numberList) {
        this.$message.warning(this.$t('GlobalSetObj.selectTime'));
        return;
      }
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.loadStartTime = this.timeValue[0];
        data.params.loadEndTime = this.timeValue[1];
      } else {
        data.params.loadStartTime = '';
        data.params.loadEndTime = '';
      }
      data.params.queryType = this.queryForm.params.queryType;
      data.params.loadSiteIdList = this.queryForm.params.loadSiteIdList;
      data.params.nextSiteIdList = this.queryForm.params.nextSiteIdList;
      data.params.numberList = this.queryForm.params.numberList;
      data.params.loadUserIdList = this.queryForm.params.loadUserIdList;
      data.params.loadSiteStates = this.queryForm.params.loadSiteStates;
      data.params.loadSiteDepartmentIds = this.queryForm.params.loadSiteDepartmentIds;
      data.params.scanNumberType = this.queryForm.params.scanNumberType;
      data.params.scanNumberList = [];
      if (this.queryForm.params.waybillNumber) {
        let arr = [];
        arr = this.queryForm.params.waybillNumber.split('\n').filter((item) => item.trim() !== '');
        arr = arr.map((item) => item.trim());
        data.params.scanNumberList = arr;
        if (arr.length > 2000) {
          data.params.scanNumberList = arr.slice(0, 2000);
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      loadUnloadSumpageQuery(data)
        .then((res) => {
          if (res.code === 200) {
            if (res.data?.loadUnloadSumVO && res.data?.loadUnloadSumVO?.length) {
              res.data?.loadUnloadSumVO.pop([]);
            }
            this.queryForm.total = res.data?.loadUnloadSumVO?.total;
            this.tableData = res.data?.loadUnloadSumVO?.records;
            this.pageSumLoad = res.data?.pageSumLoad;
            if (val === 1) {
              loading.close();
            }
            console.log(this.tableData, 'tableData');
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.number = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.number = val;
      this.getSearch();
    },
    // 获取最近一星期时间
    getTimer() {
      const today = dayjs().format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    closeDrawer() {
      this.dialogVisible = false;
      this.photoSeeRefVisible = false;
      this.dialogVisible01 = false;
      console.log(this.photoSeeRefVisible, 'photoSeeRefVisible');
    },
    allExportOrder(type) {
      const data = {};
      if ((!this.timeValue || this.timeValue.length <= 0) && !this.numberList) {
        this.$message.warning(this.$t('GlobalSetObj.selectTime'));
        return;
      }
      if (this.timeValue && this.timeValue.length > 0) {
        data.loadStartTime = this.timeValue[0];
        data.loadEndTime = this.timeValue[1];
      } else {
        data.loadStartTime = '';
        data.loadEndTime = '';
      }

      data.queryType = this.queryForm.params.queryType;
      data.loadSiteIdList = this.queryForm.params.loadSiteIdList;
      data.nextSiteIdList = this.queryForm.params.nextSiteIdList;
      data.numberList = this.queryForm.params.numberList;
      data.loadUserIdList = this.queryForm.params.loadUserIdList;
      data.loadSiteStates = this.queryForm.params.loadSiteStates;
      data.loadSiteDepartmentIds = this.queryForm.params.loadSiteDepartmentIds;
      data.scanNumberType = this.queryForm.params.scanNumberType;
      data.scanNumberList = [];
      if (this.queryForm.params.waybillNumber) {
        let arr = [];
        arr = this.queryForm.params.waybillNumber.split('\n').filter((item) => item.trim() !== '');
        arr = arr.map((item) => item.trim());
        data.scanNumberList = arr;
        if (arr.length > 2000) {
          data.scanNumberList = arr.slice(0, 2000);
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
      }
      if (type === 1) {
        // 导出汇总
        loadUnloadSumExportAll(data).then((res) => {
          if (res.code === 200) {
            goRWExportList(this);
          }
        });
      } else if (type === 2) {
        // 导出明细
        loadUnloadSumExportDetail(data).then((res) => {
          if (res.code === 200) {
            goRWExportList(this);
          }
        });
      } else {
        // 导出明细
        loadUnloadSumTfkInfo(data).then((res) => {
          if (res.code === 200) {
            goRWExportList(this);
          }
        });
      }
    },
    airExportOrder() {
      const data = {};
      if ((!this.timeValue || this.timeValue.length <= 0) && !this.numberList) {
        this.$message.warning(this.$t('GlobalSetObj.selectTime'));
        return;
      }
      if (this.timeValue && this.timeValue.length > 0) {
        data.loadStartTime = this.timeValue[0];
        data.loadEndTime = this.timeValue[1];
      } else {
        data.loadStartTime = '';
        data.loadEndTime = '';
      }

      data.queryType = this.queryForm.params.queryType;
      data.loadSiteIdList = this.queryForm.params.loadSiteIdList;
      data.nextSiteIdList = this.queryForm.params.nextSiteIdList;
      data.numberList = this.queryForm.params.numberList;
      data.loadUserIdList = this.queryForm.params.loadUserIdList;
      data.loadSiteStates = this.queryForm.params.loadSiteStates;
      data.loadSiteDepartmentIds = this.queryForm.params.loadSiteDepartmentIds;
      tfkDirExport(data).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    getVehicleTagNumber01() {
      this.queryForm.params.numberList = [];
      this.numberList = '';
    },
    getSiteList(val) {
      const data = {
        siteName: val
      };
      loadUnloadSumuserAndSite(data).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data.siteList;
        }
      });
    },
    getOperationUserInfo(val) {
      const data = {
        operateUserName: val
      };
      loadUnloadSumuserAndSite(data).then((res) => {
        if (res.code === 200) {
          this.userList = res.data.operatorList;
        }
      });
    },
    // 创建汇总行数据
    createSummaryRowData() {
      const summaryData = {}

      // 为所有表头字段创建空值，避免显示 undefined
      ;[...this.tableHeaderList, ...this.tableHeaderList1].forEach((header) => {
        summaryData[header.prop] = '';
      });

      return summaryData;
    },
    // el-table 合并单元格方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 汇总行不需要特殊的合并处理，让每列正常显示
      // 这样可以在每个相关列显示对应的统计信息
      return {
        rowspan: 1,
        colspan: 1
      };
    }
  }
};
</script>

<style scoped>
.selectClass >>> .el-col {
  margin-right: 20px;
}

.app-container >>> .drawerClass header {
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 0 !important;
  padding: 20px 20px 20px !important;
}

.app-container >>> .el-form--label-top .el-form-item__label {
  width: 100% !important;
}

.app-container >>> .selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  color: #4e5969;
  border: none;
  text-align: left;
}

.app-container >>> .selectLabel .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep.el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.WaybillNumber {
  color: #00A551;
  cursor: pointer;
}

.app-container >>> .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}

.text-total {
  font-size: 14px;
  font-weight: bold;
}

.text-color-33B44E {
  color: #33b44e;
  font-weight: bold;
}
</style>
